import authRoles from '../../../auth/authRoles';
import Patients from './Patients';

const PatientsConfig = {
  settings: {
    layout: {
      style: 'layoutMarketingV2',
      config: {
        header: {
          display: true
        },
        footer: {
          display: true
        }
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/patients',
      element: <Patients />,
    },
  ],
};

export default PatientsConfig;